import * as React from 'react'
import { ReactElement } from 'react'
import { TimeListItemDto } from '../../../../../config/registrationConfig'
import { LineItemProps } from './LineItem'
import { COMMAND_PREFIX } from '../../../../../pages/Commands'
import { Stack } from '@fluentui/react'
import { Badge, Text } from '@fluentui/react-components'
import { MoneyRegular, ShiftsRegular } from '@fluentui/react-icons'
import TimeText from '../../../../Text/Time/TimeText'
import MoneyText from '../../../../Text/Currency/MoneyText'
import { Link } from 'react-router-dom'
import PersonAvatar from '../../../../PersonAvatar'
import FormattedDateBadge from '../../../../Date/FormattedDateBadge'
import useUsers from '../../../../../hooks/useUsers'

export default function TimeLineItem({ lineItem, entity, findQuantity }: LineItemProps<TimeListItemDto>): ReactElement {
    const { getUserById } = useUsers()

    const timeItem: TimeListItemDto =
        findQuantity(lineItem?.entityId ?? entity?.id)?.map(quantity => ({
            ...entity,
            id: lineItem?.entityId ?? entity?.id,
            duration: quantity.amount,
            rate: { amount: quantity.rate, currency: entity?.rate.currency || 'EUR' },
            description: quantity.description,
            date: quantity.date,
            user: getUserById(quantity.user),
        }))?.[0] || entity

    return (
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 's1' }}>
            <PersonAvatar name={timeItem?.user?.fullName} color={entity ? 'colorful' : 'neutral'} />

            <Stack horizontal={false} verticalAlign="center" tokens={{ childrenGap: 's2 s1', padding: 's2 0' }} wrap>
                {entity ? (
                    <Link to={`${COMMAND_PREFIX}/time/${timeItem?.id}/edit`}>
                        <Text>{timeItem?.description}</Text>
                    </Link>
                ) : (
                    <Text strikethrough>{timeItem?.description}</Text>
                )}
                <Stack horizontal tokens={{ childrenGap: 's2' }}>
                    <FormattedDateBadge date={timeItem?.date} />
                    <Badge size="medium" icon={<ShiftsRegular />} appearance="tint">
                        <TimeText value={timeItem?.duration} />
                    </Badge>
                    <Badge size="medium" icon={<MoneyRegular />} appearance="tint">
                        <MoneyText value={timeItem?.rate} textProps={{ size: 200 }} />
                    </Badge>
                </Stack>
            </Stack>
        </Stack>
    )
}
